import React from "react";

export default function DashboardSection(props) {

    const { filterLabel,
        resultCountComponent,
        sortSelectComponent,
        pageSizeSelectComponent,
        paginationComponent,
        isLoading,
        clearAllFiltersLabel,
        onClearAllFilters} = props;
    let filterLabelFinal = filterLabel;
    if (clearAllFiltersLabel.length > 0 ) {
        filterLabelFinal = filterLabelFinal + " | ";
    }
    return (
        !isLoading ?
            <div className="product-list-dashboard">
                <div className="product-list-dashboard-filter-labels">
                    <h4>{filterLabelFinal} </h4>
                    <h4 className="decorate" onClick={onClearAllFilters}> {clearAllFiltersLabel}</h4>
                </div>
                <div className="product-list-dashboard-options">
                    <div className="product-list-dashboard-filters">
                        {resultCountComponent}
                    </div>
                    <div className="product-list-dashboard-controls">
                        {sortSelectComponent}
                        {pageSizeSelectComponent}
                    </div>
                    {paginationComponent}
                </div>
            </div>
            :
            null
    );
}